module.exports = __webpack_public_path__ + "static/media/HiraginoSansGBW6.a5896341.svg";